import { MOBILE_APP_CATALOG } from "./mobile-apps";
import type mobileAppsContract from "./generated/mobile-apps-contract";

type Apps = typeof mobileAppsContract.apps;
export type MobileAppName = {
  [Name in keyof Apps]: Apps[Name]["source"] extends "mobile-app"
    ? Name
    : never;
}[keyof Apps];

export const MOBILE_APP_NAMES = Object.keys(MOBILE_APP_CATALOG).filter(
  (name) => MOBILE_APP_CATALOG[name].source === "mobile-app",
) as MobileAppName[];

export const MOBILE_APP_DEFINITIONS = Object.fromEntries(
  MOBILE_APP_NAMES.map((name) => [name, MOBILE_APP_CATALOG[name]]),
) as Record<MobileAppName, (typeof MOBILE_APP_CATALOG)[string]>;
